module.exports = __webpack_public_path__ + "media/images/resource-placeholder03-228538db383f4062d36878e4bea3bb97.jpg";